const initialState = {
	type: '',
	version: '',
	originX: '',
	originY: '',
	left: 0,
	top: 0,
	width: 0,
	height: 0,
	fill: null,
	stroke: '',
	strokeWidth: 1,
	strokeDashArray: null,
	strokeLineCap: '',
	strokeDashOffset: 0,
	strokeLineJoin: '',
	strokeUniform: false,
	strokeMiterLimit: 0,
	scaleX: 0,
	scaleY: 0,
	angle: 0,
	flipX: false,
	flipY: false,
	opacity: 0,
	shadow: null,
	visible: true,
	backgroundColor: '',
	fillRule: '',
	paintFirst: '',
	globalCompositeOperation: '',
	skewX: 0,
	skewY: 0,
	path: [],
	id: '',
	action: ''
};

const sketch = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_SKETCH_DATA':
		{
			return action.payload;
		}

		default:
			return state;
	}
};

export default sketch;
